import { render, staticRenderFns } from "./vehicle-attributes.vue?vue&type=template&id=50a82188&scoped=true&"
import script from "./vehicle-attributes.vue?vue&type=script&lang=ts&"
export * from "./vehicle-attributes.vue?vue&type=script&lang=ts&"
import style0 from "./vehicle-attributes.vue?vue&type=style&index=0&id=50a82188&prod&lang=scss&scoped=true&"
import style1 from "./vehicle-attributes.vue?vue&type=style&index=1&id=50a82188&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a82188",
  null
  
)

export default component.exports